import { AuthService, ReadLayer } from "@adfenix/types";
import { SERVICES_URL } from "api/helper";
import { get, post } from "api/http";

export interface ReadLayerQuery {
  index: string;
  service: string;

  page?: number;
  pageSize?: number;
  sortOnColumn?: string;
  sortAscending?: boolean;
  facets?: Array<ReadLayerQueryFacet>;
  filters: Array<ReadLayerQueryFilter>;
  searchTermColumns?: Array<string>;
  searchTerm?: string;
}

export interface ReadLayerSuggestionQuery {
  index: string;
  service: string;
  size: number;
  searchTerm: string;
  columns: Array<string>;
  filters: Array<ReadLayerQueryFilter>;
}

export interface ReadLayerQueryFilter {
  column: string;
  displayValue?: string;
  value?: string;
  values?: string[];
  fromDateTimeUtc?: string;
  toDateTimeUtc?: string;
  exclude?: boolean;
}

export interface ReadLayerQueryFacet {
  column: string;
  size: number;
}

export interface ReadLayerFacetResult {
  column: string;
  hasMore: boolean;
  values: Array<ReadLayerFacetValue>;
}

export interface ReadLayerFacetValue {
  value: string;
  count: number;
}

export type ResultValue = unknown;

export interface ReadLayerResult<ResultValue> {
  documents: Array<ResultValue>;
  totalNumberOfDocuments: number;
  facets: Array<ReadLayerFacetResult>;
}

export const getReadLayer = <T>(index: string, id: string): Promise<T> =>
  get(`${SERVICES_URL}/read-layer/auth/v1/read-layer/${index}/get/${id}`);

export const searchReadLayer = <T>(
  query: ReadLayerQuery
): Promise<ReadLayerResult<T>> =>
  post(
    `${SERVICES_URL}/${query.service}/auth/v1/read-layer/${query.index}/query/?IncludeCampaigns=true`,
    query
  );

export const getReadLayerSuggestions = (
  query: ReadLayerSuggestionQuery
): Promise<Array<ReadLayerFacetResult>> =>
  post(
    `${SERVICES_URL}/${query.service}/auth/v1/read-layer/${query.index}/suggestions/`,
    query
  );

export const getReadLayerStats = (
  query: ReadLayer.ReadLayerStatisticsRequest,
  index: string,
  service: string
): Promise<ReadLayer.ReadLayerStatisticsResponse> =>
  post(`${SERVICES_URL}/${service}/auth/v1/read-layer/${index}/stats/`, query);

export const getActiveCampaignPropertyId = (
  propertyId?: string
): Promise<ReadLayerResult<ResultValue>> =>
  post(`${SERVICES_URL}/campaign/auth/v1/read-layer/campaign-overview/query`, {
    filters: [{ column: "property.id", value: propertyId }]
  });

export const getHqUsers = (
  hqId: string
): Promise<ReadLayerResult<AuthService.UserSearchModel>> =>
  searchReadLayer({
    index: "User",
    service: "auth",
    filters: [
      { column: "hqs.id", value: hqId },
      { column: "deleted", value: "false" },
      { column: "isSeller", value: "false" }
    ],
    pageSize: 1000,
    sortOnColumn: "email",
    sortAscending: true
  });
